<app-section-loader [loading]="loading"></app-section-loader>
<h2 class="mat-dialog-title" mat-dialog-title class="text-secondary">
  {{ importPhase === 3 ? "Imported Score Report" : "Import Scores" }}
</h2>
<form [formGroup]="importScoresForm">
  <div *ngIf="importPhase === 1">
    <mat-dialog-content>
      <div class="form-group">
        <div class="label">
          Upload from file<span
            *ngIf="!IsFile"
            class="text-danger"
            style="font-size: 12px"
            >*
          </span>
          <small class="text-danger" style="margin-left: 2px"
            >(Accepted file format - .xlsx)</small
          >
        </div>
        <div class="file-upload">
          <input
            #fileInput
            formControlName="fileInput"
            type="file"
            accept=".xlsx"
            id="file"
            (change)="onUpload($event)"
            style="visibility: hidden"
            required
          />
          <div class="file-upload-text">
            {{ fileName ? fileName : "Select a file" }}
          </div>
          <button mat-raised-button color="primary" (click)="fileInput.click()">
            Browse
          </button>
        </div>
      </div>
      <div class="template-download mb-3">
        <a
          href="https://hugdevs3.s3.amazonaws.com/Templates/Scores_Template.xlsx"
          download
          >Download a student scores template</a
        >
      </div>
      <p class="mb-1">Choose a school for which you are uploading scores:</p>
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Schools</mat-label>
        <mat-select
          formControlName="school"
          [(ngModel)]="importScoreModal.school"
          required
        >
          <mat-option>
            <ngx-mat-select-search
              style="width: 100%"
              [formControl]="schoolControl"
              [noEntriesFoundLabel]="'No matching School found'"
              placeholderLabel="Search School"
            >
            </ngx-mat-select-search>
          </mat-option>
          <mat-option *ngFor="let school of schoolOptions" [value]="school.id">
            {{ school.school_name }}
            {{ school.uuid ? "(" + school.uuid + ")" : "" }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>Cancel</button>
      <button
        mat-raised-button
        color="primary"
        (click)="importScores()"
        [disabled]="!importScoresForm.valid"
      >
        Upload
      </button>
    </mat-dialog-actions>
  </div>
</form>
<div *ngIf="importPhase === 2">
  <mat-dialog-content *ngIf="importSuccessful">
    <div class="alert-message-popup">
      <a class="text-success">
        <mat-icon style="font-size: 40px">check_circle</mat-icon>
      </a>
      <h2 class="h1 mt-6 mb-4">File uploaded successfully !</h2>
      <p class="mb-0">
        {{ successReport?.imported?.length }} records successfully imported
      </p>
      <p class="mb-0">
        {{ successReport?.updated?.length }} records successfully updated
      </p>
      <p class="text-danger mb-0">
        {{ successReport?.failed.length }} records failed to import
      </p>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end" *ngIf="importSuccessful">
    <button mat-button *ngIf="scoreDetails" (click)="importPhase = 3">
      View Details
    </button>
    <button
      mat-raised-button
      mat-dialog-close
      color="primary"
      (click)="dialogRef.close(true)"
    >
      Done
    </button>
  </mat-dialog-actions>
  <mat-dialog-content *ngIf="!importSuccessful">
    Uh oh, something went wrong! Please try again
  </mat-dialog-content>
  <mat-dialog-actions align="end" *ngIf="!importSuccessful">
    <button mat-button (click)="dialogRef.close(false)">Dismiss</button>
    <button mat-raised-button color="primary" (click)="resetForm()">
      Try Again
    </button>
  </mat-dialog-actions>
</div>
<div *ngIf="importPhase === 3">
  <mat-dialog-content>
    <div *ngIf="successReport?.imported?.length">
      <p class="modal-text m-0">
        {{ successReport?.imported.length }} student records imported:
      </p>
      <div class="list-name-scroll">
        <ul class="list-unstyled list-name row">
          <li class="col-md-6" *ngFor="let student of successReport?.imported">
            <span class="text"
              >{{ student.first_name }} {{ student.second_name }}
              {{ student.last_name }}
            </span>
          </li>
        </ul>
      </div>
    </div>
    <div *ngIf="successReport?.updated?.length">
      <p class="modal-text m-0">
        {{ successReport?.updated.length }} student records updated:
      </p>
      <div class="list-name-scroll">
        <ul class="list-unstyled list-name row">
          <li class="col-md-6" *ngFor="let student of successReport?.updated">
            <span class="text"
              >{{ student.first_name }} {{ student.second_name }}
              {{ student.last_name }}
            </span>
          </li>
        </ul>
      </div>
    </div>
    <div *ngIf="successReport?.failed?.length">
      <p class="modal-text m-0">
        {{ successReport?.failed?.length }} student records failed:
      </p>
      <span><em>Students could not be found</em></span>
      <div class="list-name-scroll">
        <ul class="list-unstyled list-name row">
          <li class="col-md-6" *ngFor="let status of successReport?.failed">
            <span class="text"
              >{{ status.first_name }} {{ status.second_name }}
              {{ status.last_name }} - {{ status.message }}</span
            >
          </li>
        </ul>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-raised-button color="primary" (click)="dialogRef.close(true)">
      Dismiss
    </button>
  </mat-dialog-actions>
</div>
